export default __webpack_public_path__ + "static/media/230.20ec4c39.jpg";